import { render, staticRenderFns } from "./team_match_invite.vue?vue&type=template&id=eb075080&"
import script from "./team_match_invite.vue?vue&type=script&lang=js&"
export * from "./team_match_invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports